import { getP, pcode, stageOf } from '../../core/selectors.js';
import { render } from '../../core/shell.js';
import { save } from '../../core/store.js';
import { toast } from '../../core/ui.js';

// Drag a project card between stage columns on the board view.
export function initProjectDnd() {
  let dragP = null;
  const col = (e) => e.target.closest && e.target.closest('[data-pcol]');
  document.addEventListener('dragstart', (e) => {
    const t = e.target.closest && e.target.closest('[data-pcard]');
    if (!t) return;
    dragP = t.dataset.pcard;
    try { e.dataTransfer.effectAllowed = 'move'; e.dataTransfer.setData('text/plain', 'x'); } catch (x) { /* some browsers block this */ }
  });
  document.addEventListener('dragover', (e) => { const c = col(e); if (c && dragP) { e.preventDefault(); c.classList.add('over'); } });
  document.addEventListener('dragleave', (e) => { const c = col(e); if (c) c.classList.remove('over'); });
  document.addEventListener('drop', (e) => {
    const c = col(e);
    if (!c || !dragP) return;
    e.preventDefault();
    const p = getP(dragP);
    dragP = null;
    if (!p) return;
    p.stage = c.dataset.pcol;
    save(); render();
    toast(pcode(p) + ' moved to ' + stageOf(p).name);
  });
  document.addEventListener('dragend', () => { dragP = null; document.querySelectorAll('[data-pcol].over').forEach((x) => x.classList.remove('over')); });
}
